<template>
    <MFAValidateForm :authenticationMethods="authenticationMethods" :credential="credential" :redirect="redirect"
      :defaultContact="defaultContact">
    </MFAValidateForm>
  </template>

  <script>
  import MFAValidateForm from "@/Components/MFA/MFAValidateForm.vue";

  export default {
    components: {
      MFAValidateForm
    },
    props: {
      redirect: String,
      authenticationMethods: Object,
      credential: Object,
      defaultContact: Object,
    },
    data() {
      return {}
    },
    methods: {},
    computed: {}
  }
  </script>
